import React, { useCallback, useEffect, useState } from "react";

import { faExchangeAlt } from "@fortawesome/pro-solid-svg-icons/faExchangeAlt";
import { faLongArrowAltLeft } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltLeft";
import { faLongArrowAltRight } from "@fortawesome/pro-solid-svg-icons/faLongArrowAltRight";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import NylasFormSyncDirection from "@app/scene/settings/enum/NylasFormSyncDirection";
import {
  convertNylesOptionsToSyncDirection,
  convertSyncDirectionToNylesOptions,
} from "@app/scene/settings/util/syncDirection";
import layout from "@app/styles/layout";
import NylasSyncOptions from "@app/types/nylas/NylasSyncOptions";
import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

import DirectionCard from "./DirectionCard";

interface Props {
  analyticIssuer?: AnalyticsService;
  onChange?: (value: NylasSyncOptions) => void;
  value?: NylasSyncOptions;
}

const SyncDirection: React.FC<Props> = ({ analyticIssuer, onChange, value }) => {
  const intl = useIntl();
  const [direction, setDirection] = useState<NylasFormSyncDirection>(
    convertNylesOptionsToSyncDirection(value)
  );
  useEffect(() => {
    setDirection(convertNylesOptionsToSyncDirection(value));
  }, [value]);

  const handleChange = useCallback(
    (value: NylasFormSyncDirection) => {
      let actionValue: string;
      if (value === NylasFormSyncDirection.OUTGOING) {
        actionValue = "MMC to Calendar";
      } else if (value === NylasFormSyncDirection.INCOMING) {
        actionValue = "Calendar to MMC";
      } else {
        actionValue = "Two Way";
      }
      analyticIssuer?.clicked(["Sync Setup", actionValue]);
      setDirection(value);
      onChange?.(convertSyncDirectionToNylesOptions(value));
    },
    [analyticIssuer, onChange, setDirection]
  );

  return (
    <Row gutter={layout.spacerM}>
      <Col>
        <DirectionCard
          active={direction === NylasFormSyncDirection.OUTGOING}
          icon={faLongArrowAltRight}
          name={intl.formatMessage({
            id: "settings.calendar.createEditPane.syncDirection.mmcToCalendar",
            defaultMessage: "MMC to Calendar",
            description: "Settings calendar create/edit pane - sync direction - MMC to Calendar",
          })}
          onClick={() => handleChange(NylasFormSyncDirection.OUTGOING)}
        />
      </Col>
      <Col>
        <DirectionCard
          active={direction === NylasFormSyncDirection.INCOMING}
          icon={faLongArrowAltLeft}
          name={intl.formatMessage({
            id: "settings.calendar.createEditPane.syncDirection.calendarToMmc",
            defaultMessage: "Calendar To MMC",
            description: "Settings calendar create/edit pane - sync direction - Calendar To MMC",
          })}
          onClick={() => handleChange(NylasFormSyncDirection.INCOMING)}
        />
      </Col>
      <Col>
        <DirectionCard
          active={direction === NylasFormSyncDirection.TWO_WAY}
          icon={faExchangeAlt}
          name={intl.formatMessage({
            id: "settings.calendar.createEditPane.syncDirection.2way",
            defaultMessage: "Two-Way",
            description: "Settings calendar create/edit pane - sync direction - 2 way",
          })}
          onClick={() => handleChange(NylasFormSyncDirection.TWO_WAY)}
        />
      </Col>
    </Row>
  );
};
export default SyncDirection;
